import React from 'react';
import './css/popupstyle.css';
import DeleteIcon from '../components/css/dark/img/delete.svg';
import CreateDashboardIcon from '../components/css/dark/img/create-dashboard.svg';
import exportIcon from '../components/css/dark/img/theme-images/export.svg';
import ResendPassword from '../components/css/dark/img/change-passowrd.svg';
import Error from '../components/css/dark/img/error.svg';
import Success from '../components/css/dark/img/success.svg';
import DeletePopup from '../components/ConfirmDeletePopup';
import CreateDashboardPopup from '../components/CreateDashboardPopup';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import { debug } from 'util';
import { userService } from '../_services';

class ManageUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            wname: this.props.wholesaler_name,
            userdata: JSON.parse(localStorage.getItem('user')),
            DeletePopup: false,
            CreateDashboardPopup: false,
            ResendPasswordPopup: false,
            EditUserPopup: false,
            DeleteSection: true,
            DashboardSection: true,
            ResendPasswordSection: true,
            EditUserSection: true,
            filterId: '',
            UserList: [],
            UserList_Temp: [],
            mainAPIresult: [],
            loader: true,
            containerHide: false,
            UserName: '',
            UserEmail: '',
            UserId: '',
            OpStatus: false,
            SortBy: '',
            activePage: 1,
            ConfirmSection: '',
            currentPaging: 1,
            mUserSearch: '',
            Data_Not_Found: ''
        };
        this.CloseResendPopup = this.CloseResendPopup.bind(this);
        this.CloseEditUserPopup = this.CloseEditUserPopup.bind(this);
        this.ExportUsers = this.ExportUsers.bind(this);
    }
    componentDidMount() {
        this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.wholesaler_Id, this.state.userdata.userrole);
        if (this.props.confirmSection == 'DeleteSection') {
            this.setState({ loader: true, containerHide: true });
            this.handleNew();
        } else if (this.props.confirmSection == 'DashboardSection') {
            this.setState({ loader: true, containerHide: true });
            this.createDashboard();
        } else if (this.props.confirmSection == 'ResendPasswordSection') {
            this.setState({ loader: true, containerHide: true });
            this.handleSubmit();
        }
        $('.pagination li:first-child').text('First');
        $('.pagination li:last-child').text('Last');
        $('.configure-close').on('click', function () {
            $(".configure-error").animate({
                right: -450 + 'px'
            }, 1000, function () {
                $(".configure-error").removeClass('active');
            });
        });
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    componentDidUpdate() {
        //if (this.state.userlist == [] || this.state.userlist.length == 0) {
        //    this.getdistributorlist(this.state.userdata.paramsname, this.state.userdata.userrole);
        //}
        $('.pagination li:first-child').text('First');
        $('.pagination li:last-child').text('Last');
    }
    GetDistributorList(roleName, wholesaler_Id, roleType) {
        $("#SearcInput").prop('disabled', true);
        roleName = this.state.userdata.paramsname;
        wholesaler_Id = this.state.userdata.wholesaler_Id;
        roleType = this.state.userdata.userrole;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ roleName, wholesaler_Id, roleType })
            };
            return fetch(`/api/ws/Distributor_DashList`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        let tempforthisonly = apidata;
                        let userlistobj = JSON.parse(JSON.stringify(apidata));
                        userlistobj.forEach(function (a, i) {
                            // eslint-disable-next-line no-unused-expressions
                            a.userId = a.userId,
                                a.userName = a.userName,
                                a.userEmail = a.userEmail,
                                a.srNo = i + 1
                        });
                        let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
                        this.setState({ UserList: tempforthisonly, mainAPIresult: apidata, UserList_Temp: usertemplistobj, SortBy: 'all', loader: false, containerHide: true });
                        $("#SearcInput").prop('disabled', false);

                        if (this.props.manageUserPagin > 1) {
                            this.handlePageChange(this.props.manageUserPagin);
                        }
                        if (!userService.Check_Null_Empty(this.props.manageUserSearch)) {
                            $('#SearcInput').val(this.props.manageUserSearch)
                            this.FilterRecords();
                        }

                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    FilterRecords = (e) => {
        let serachText = $('#SearcInput').val();

        $('.tabs a').removeClass('active');
        $('.tabs a').eq(0).addClass('active');


        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.userEmail.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.userEmail.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;

        this.setState({ activePage: 1, UserList_Temp: usertemplistobj, UserList: copyuserlistobj, loader: false, mUserSearch: serachText, SortBy: 'all' });

    }
    handleSearchFilter = (e) => {
        let serachText = $('#SearcInput').val();

        $('.tabs a').removeClass('active');
        $('.tabs a').eq(0).addClass('active');


        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.userEmail.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.userEmail.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

        let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
        usertemplistobj.forEach(function (a, i) {
            // eslint-disable-next-line no-unused-expressions
            a.userId = a.userId,
                a.userName = a.userName,
                a.userEmail = a.userEmail,
                a.srNo = i + 1
        });
        this.setState({ activePage: 1, UserList_Temp: usertemplistobj, UserList: copyuserlistobj, loader: false, mUserSearch: serachText, SortBy: 'all' });
    }
    deletePopup = e => {
        this.setState({ filterId: 2 });
        e.stopPropagation();
        let userName = $(e.target).attr('attname');
        let userEmail = $(e.target).attr('attmail');
        let userId = $(e.target).attr('attid');
        let titleText = 'Are you sure want to delete this dashboard?';
        let ConfirmSection = 'DeleteSection';
        let pagin = this.state.currentPaging;
        let mGroupSearch = this.state.mUserSearch;

        this.props.closeResetPasswordPopup(userName, userEmail, userId, titleText, ConfirmSection, pagin, mGroupSearch);
        this.props.openDeletePopup();
    }
    CloseCreatPopup = e => {
        this.setState({ filterId: 1 });
        e.stopPropagation();
        this.setState({
            CreateDashboardPopup: !CreateDashboardPopup, UserName: $(e.target).attr('attname'), UserEmail: $(e.target).attr('attmail'), UserId: $(e.target).attr('attid')
        });
    }
    CloseResendPopup = e => {
        e.stopPropagation();
        this.setState({
            ResendPasswordPopup: !this.state.ResendPasswordPopup
        });
    }
    CloseEditUserPopup = e => {
        e.stopPropagation();
        this.setState({
            EditUserPopup: !this.state.EditUserPopup
        });
    }
    handleNew = e => {
        $('#DeletePopupLoader').show();
        $('.searchtextarea').val('');
        let distEmail = this.props.manageUserEmail;
        let distName = this.props.manageUserName;
        let DistId = this.props.manageUserId;
        let wholeSaler = this.state.userdata.paramsname;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ distName, distEmail, wholeSaler })
            };
            return fetch(`/api/user/RemoveDistributorAccount`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });
                                $(".configure-error").addClass('green active');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);

                                this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.userrole);

                                this.setState({
                                    loader: false
                                });
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    loader: false
                                });
                                $(".configure-error").addClass('active');
                            }
                        } else {
                            $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                loader: false
                            });
                            $(".configure-error").addClass('active');
                        }
                    }
                    catch (error) {
                        $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            loader: false
                        });
                        $(".configure-error").addClass('active');
                    }
                });
        }
        catch (error) {
        }

    }
    createDashboardPopup = e => {
        e.stopPropagation();
        let userName = $(e.target).attr('attname');
        let userEmail = $(e.target).attr('attmail');
        let userId = $(e.target).attr('attid');
        let titleText = 'Click on confirm to create a dashboard';
        let ConfirmSection = 'DashboardSection';
        let pagin = this.state.currentPaging;
        let mGroupSearch = this.state.mUserSearch;

        this.props.closeResetPasswordPopup(userName, userEmail, userId, titleText, ConfirmSection, pagin, mGroupSearch);
        this.props.openDeletePopup();
    }
    createDashboard = e => {
        $('#CreatePopupLoader').show();
        $('.searchtextarea').val('');
        let distEmail = this.props.manageUserEmail;
        let distName = this.props.manageUserName;
        let wholeSaler = this.state.userdata.paramsname;
        let wholesaler_Id = this.state.userdata.wholesaler_Id;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ distName, distEmail, wholeSaler, wholesaler_Id })
            };
            return fetch(`/api/user/CreateDistributorAccount`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });
                                $(".configure-error").addClass('green active');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);

                                this.setState({
                                    loader: false
                                });

                                //this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.userrole);
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 3000);
                                this.setState({
                                    loader: false
                                });
                                $(".configure-error").addClass('active');
                            }
                        } else {
                            $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                loader: false
                            });
                            $(".configure-error").addClass('active');
                        }
                        this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.userrole);
                    }
                    catch (error) {
                        $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            loader: false
                        });
                        $(".configure-error").addClass('active');
                    }
                });
        }
        catch (error) {
        }
    }
    ResendPasswordPopup = e => {
        e.stopPropagation();

        let userName = $(e.target).attr('attname');
        let userEmail = $(e.target).attr('attmail');
        let userId = $(e.target).attr('attid');
        let titleText = 'Change Password';
        let ConfirmSection = 'ResendPasswordSection';
        let pagin = this.state.currentPaging;
        let mGroupSearch = this.state.mUserSearch;

        this.props.closeResetPasswordPopup(userName, userEmail, userId, titleText, ConfirmSection, pagin, mGroupSearch);
        this.props.openDeletePopup();
    }
    EditUserPopup = e => {
        e.stopPropagation();
        this.setState({
            EditUserPopup: !this.state.EditUserPopup, UserName: $(e.target).attr('attname'), UserEmail: $(e.target).attr('attmail'), UserId: $(e.target).attr('attid')
        });
    }
    handleEditUser = e => {
        let UserId = e[0];
        let New_UserName = e[1];
        let New_UserEmail = e[2];
        let WholeSaler = this.state.userdata.paramsname;
        let Old_UserName = this.state.UserName;
        let Old_UserEmail = this.state.UserEmail;
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Old_UserName, Old_UserEmail, UserId, WholeSaler, New_UserName, New_UserEmail })
            };
            return fetch(`/api/user/Edit_User_Details_ByWholesaler`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });

                                $(".configure-error").addClass('green active');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, EditUserPopup: false, UserList: []
                                });
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    ...this.state, EditUserPopup: false, UserList: []
                                });
                                $(".configure-error").addClass('active');
                            }
                        } else {
                            $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                ...this.state, EditUserPopup: false, UserList: []
                            });
                            $(".configure-error").addClass('active');
                        }

                    }
                    catch (error) {
                        $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, EditUserPopup: false, UserList: []
                        });
                        $(".configure-error").addClass('active');
                    }
                });
        }
        catch (error) {
        }
    }
    handleSubmit = e => {
        $('.searchtextarea').val('');
        this.setState({
            loader: true
        });
        let distEmail = this.props.manageUserEmail;
        let distName = this.props.manageUserName;
        let Wholesaler = this.state.userdata.paramsname;
        let NewPassword = this.props.manageUserPassword[0];
        let ConfirmNewPassword = this.props.manageUserPassword[1];
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ distEmail, distName, Wholesaler, NewPassword, ConfirmNewPassword })
            };
            return fetch(`/api/user/ResetDistributorAccountPwd`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({
                                    OpStatus: true
                                });

                                $(".configure-error").addClass('green active');
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Success');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    loader: false
                                });
                                this.GetDistributorList(this.state.userdata.paramsname, this.state.userdata.userrole);
                            } else {
                                $('.configure-error-content').text(apidata[0].status_message);
                                $('.configure-heading').text('Error');
                                $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                                this.setState({
                                    loader: false
                                });
                                $(".configure-error").addClass('active');
                            }
                        } else {
                            $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                            $('.configure-heading').text('Error');
                            $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                            this.setState({
                                loader: false
                            });
                            $(".configure-error").addClass('active');
                        }

                    }
                    catch (error) {
                        $('.configure-error-content').text('Whoops, something went wrong. Please try again');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, ResendPasswordPopup: false, UserList: []
                        });
                        $(".configure-error").addClass('active');
                    }
                });
        }
        catch (error) {
        }
    }
    checkTabClick = e => {
        let s1 = JSON.parse(JSON.stringify(this.state.mainAPIresult));
        $('#SearcInput').val('');
        let clickedTab = $(e.target).attr('data-text');
        if (clickedTab == 'all') {

            $('.tabs a').removeClass('active');
            $('.tabs a').eq(0).addClass('active');
            let userlistobj = s1.filter(function (e1) {
                return true;
            });
            userlistobj.forEach(function (a, i) {
                // eslint-disable-next-line no-unused-expressions
                a.userId = a.userId,
                    a.userName = a.userName,
                    a.userEmail = a.userEmail,
                    a.srNo = i + 1
            });
            let original_record00 = JSON.parse(JSON.stringify(userlistobj));
            let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
            this.setState({ activePage: 1, UserList_Temp: usertemplistobj, UserList: original_record00, loader: false, SortBy: 'all' });


        } else if (clickedTab == 'withDashboard') {
            let s2 = JSON.parse(JSON.stringify(this.state.mainAPIresult));
            $('.tabs a').removeClass('active');
            $('.tabs a').eq(1).addClass('active');
            let userlistobj11 = s2.filter(function (e1) {
                return e1.userId != "0";
            });
            userlistobj11.forEach(function (a, i) {
                // eslint-disable-next-line no-unused-expressions
                a.userId = a.userId,
                    a.userName = a.userName,
                    a.userEmail = a.userEmail,
                    a.srNo = i + 1
            });
            let original_records11 = JSON.parse(JSON.stringify(userlistobj11));
            let usertemplistobj11 = userlistobj11.length > 10 ? userlistobj11.splice(0, 10) : userlistobj11;
            this.setState({ activePage: 1, UserList_Temp: usertemplistobj11, UserList: original_records11, loader: false, SortBy: 'withdashboard' });

        } else {
            let s3 = JSON.parse(JSON.stringify(this.state.mainAPIresult));
            $('.tabs a').removeClass('active');
            $('.tabs a').eq(2).addClass('active');
            let userlistobj22 = s3.filter(function (e1) {
                return e1.userId == "0";
            });
            userlistobj22.forEach(function (a, i) {
                // eslint-disable-next-line no-unused-expressions
                a.userId = a.userId,
                    a.userName = a.userName,
                    a.userEmail = a.userEmail,
                    a.srNo = i + 1
            });
            let original_records22 = JSON.parse(JSON.stringify(userlistobj22));
            let usertemplistobj22 = userlistobj22.length > 10 ? userlistobj22.splice(0, 10) : userlistobj22;
            this.setState({ activePage: 1, UserList_Temp: usertemplistobj22, UserList: original_records22, loader: false, SortBy: 'withoutdashboard' });



        }
    }
    ExportUsers = (e) => {
        try {
            var data = "";
            var tableData = [];
            let DataList = JSON.parse(JSON.stringify(this.state.UserList));
            var header_RowData = [];
            header_RowData.push('Full Name' + ',' + 'Email' + ',' + 'Status');
            tableData.push(header_RowData.join(","));
            for (var i = 0; i < DataList.length; i++) {
                var rowData = [];
                if (DataList[i].userId == "0") {
                    rowData.push(DataList[i].userName.replace(',', '') + ',' + DataList[i].userEmail.replace(',', '') + ',' + 'No dashboard account');
                }
                else {
                    rowData.push(DataList[i].userName.replace(',', '') + ',' + DataList[i].userEmail.replace(',', '') + ',' + 'Dashboard account exists');
                }
                tableData.push(rowData.join(","));
            }
            data += tableData.join("\n");
            if (window.navigator.msSaveOrOpenBlob) {
                // IE11
                window.navigator.msSaveOrOpenBlob(new Blob([data]), "ListOfUser" + ".csv");
            } else {
                $(document.body).append('<a id="download-link" download="' + "ListOfUser" + ".csv" + '" href=' + URL.createObjectURL(new Blob([data], { type: "text/csv" })) + '/>');
            }
            $('#download-link')[0].click();
            $('#download-link').remove();

        }
        catch (error) { }
        e.preventDefault();
    }
    handlePageChange = (pageNumber) => {
        let s2 = JSON.parse(JSON.stringify(this.state.mainAPIresult));

        let sb = this.state.SortBy;
        let tempforthisonly10 = [];
        if (sb == 'withdashboard') {
            tempforthisonly10 = s2.filter(function (e1) {
                return e1.userId != "0";
            });
            tempforthisonly10.forEach(function (a, i) {
                // eslint-disable-next-line no-unused-expressions
                a.userId = a.userId,
                    a.userName = a.userName,
                    a.userEmail = a.userEmail,
                    a.srNo = i + 1
            });
        }
        else if (sb == 'withoutdashboard') {
            tempforthisonly10 = s2.filter(function (e1) {
                return e1.userId == "0";
            });
            tempforthisonly10.forEach(function (a, i) {
                // eslint-disable-next-line no-unused-expressions
                a.userId = a.userId,
                    a.userName = a.userName,
                    a.userEmail = a.userEmail,
                    a.srNo = i + 1
            });
        }
        else {
            tempforthisonly10 = s2;
            tempforthisonly10.forEach(function (a, i) {
                // eslint-disable-next-line no-unused-expressions
                a.userId = a.userId,
                    a.userName = a.userName,
                    a.userEmail = a.userEmail,
                    a.srNo = i + 1
            });
        }
        let original_records = JSON.parse(JSON.stringify(tempforthisonly10));
        let usertemplistobj10 = tempforthisonly10.length > 10 ? tempforthisonly10.splice((pageNumber - 1) * 10, 10) : tempforthisonly10;
        this.setState({ activePage: pageNumber, UserList_Temp: usertemplistobj10, loader: false, currentPaging: pageNumber });
        //UserList: original_records,  removed from above state list

    }
    render() {
        let UserList = this.state.UserList;
        let paging = 0;
        paging = UserList.length % 10 != 0 ? UserList.length + 10 - UserList.length % 10 : UserList.length;
        return (
            <div className='popup mfp-zoom-in manage-user'>
                <div className='popup_inner'>
                    <h1>{this.props.text}<button onClick={this.props.closeResetPasswordPopup}>X</button></h1>

                    {this.state.loader ? (
                        <div className="theme-loader"></div>
                    ) : null
                    }
                    <div className="populate">
                        <input type="text" id="SearcInput" className="form-control searchTable searchtextarea" autocomplete="off" name="searchtext" placeholder="Search for a User" onKeyUp={this.handleSearchFilter} />
                    </div>
                    {this.state.containerHide ? (
                        <div className="user-content">
                            <a href="javascript:void('0')" className="rep-download custom-tooltip" targe="_self"><img onClick={this.ExportUsers} src={exportIcon} className="export_icon" alt="Download Icon" /><span className="hover-tooltip">Download report</span></a>

                            <div className="tabs">
                                <a href="javascript:void('0')" data-text="all" onClick={this.checkTabClick} className="first active">All</a>
                                <a href="javascript:void('0')" data-text="withDashboard" onClick={this.checkTabClick}>With Dashboard</a>
                                <a href="javascript:void('0')" data-text="withoutDashboard" id="chk" onClick={this.checkTabClick} className="last">Without Dashboard</a>
                            </div>
                            <h3>List of Users</h3>
                            <div className="scroll-user">
                                <div className="scroll-user-scroll">
                                    {
                                        this.state.UserList != null && this.state.UserList.length > 0 ?
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th className="first-one">Sr. No.</th>
                                                        <th className="second-one">Distributor Name</th>
                                                        <th className="third-one">Email</th>
                                                        <th className="fourth-one">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="inactive_reps">
                                                    {
                                                        this.state.UserList_Temp.map((e1, i1) => {
                                                            if (e1.userId == "0") {
                                                                return (
                                                                    <tr className="userDashData createDashboardIcon">
                                                                        <td className="first-one">{e1.srNo}</td>
                                                                        <td className="second-one">{e1.userName}</td>
                                                                        <td className="third-one">{e1.userEmail}</td>
                                                                        <td className="fourth-one">
                                                                            {/*<img onClick={this.EditUserPopup.bind(this)} src={EditIcon} className="CreateDashboardIcon" attname={e1.userName} attid={e1.userId} attmail={e1.userEmail} title="Edit Details" alt="Edit" />*/}
                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.createDashboardPopup.bind(this)} src={CreateDashboardIcon} className="CreateDashboardIcon" attname={e1.userName} attid={e1.userId} attmail={e1.userEmail} alt="dashboardIcon" /><span className="hover-tooltip createNew">Create New Dashboard</span></a>
                                                                        </td>
                                                                    </tr>)

                                                            }
                                                            else {
                                                                return (
                                                                    <tr className="userDashData">
                                                                        <td className="first-one">{e1.srNo}</td>
                                                                        <td className="second-one">{e1.userName}</td>
                                                                        <td className="third-one">{e1.userEmail}</td>
                                                                        <td className="fourth-one">
                                                                            {/*<img onClick={this.EditUserPopup.bind(this)} attname={e1.userName} className="changePasswordIcon gap" attid={e1.userId} attmail={e1.userEmail} src={EditIcon} title="Edit Details" alt="Edit" />*/}
                                                                            <a href="javascript:void('0')" className="custom-tooltip delete-gap"><img onClick={this.ResendPasswordPopup.bind(this)} attname={e1.userName} className="changePasswordIcon" attid={e1.userId} attmail={e1.userEmail} src={ResendPassword} alt="ResendPasswordIcon" /><span className="hover-tooltip createNew changePassword">Change Password</span></a>
                                                                            <a href="javascript:void('0')" className="custom-tooltip"><img attname={e1.userName} attid={e1.userId} attmail={e1.userEmail} className="deleteIcon" onClick={this.deletePopup.bind(this)} src={DeleteIcon} alt="deleteIcon" /><span className="hover-tooltip deleteDash">Delete Dashboard</span></a>
                                                                        </td>
                                                                    </tr>)
                                                            }
                                                        })
                                                    }
                                                </tbody> </table> :

                                            <span className="data-not-found">{this.state.Data_Not_Found}</span>
                                    }

                                </div>
                            </div>
                            {
                                this.state.UserList != null && this.state.UserList.length > 0 ?
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={10}
                                        totalItemsCount={paging}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                    /> : null
                            }
                        </div>
                    ) :
                        <div>
                            {
                                this.state.loader ?
                                    <div className="user-content please-wait"><h3>Please wait...</h3></div> :
                                    null
                            }

                        </div>
                    }

                    <div className="configure-error">
                        <span className="configure-close"></span>
                        <div className="left">
                            {
                                this.state.OpStatus ?
                                    <img src={Success} alt="Success" /> :
                                    <img src={Error} alt="error" />
                            }

                        </div>
                        <div className="right">
                            <h3 className="configure-heading"></h3>
                            <ul className="configure-error-list">
                                <li className="configure-error-content">&nbsp;</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div >
        );
    }
}
export default ManageUser;